export default __webpack_public_path__ + "static/0003-ba3c8914377f753ee8422fa122a3a675.png";